import EventDispatcher from '../event/event-dispatcher';

/**
 * Base class for content elements.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default abstract class Content {
  /**
   * Event for checking if the content element is ready.
   *
   * @type {EventDispatcher<void>}
   * @private
   */
  private _readyEvent: EventDispatcher<void> = new EventDispatcher<void>();

  /**
   * Main container of the content element.
   *
   * @type {HTMLElement}
   */
  private _container: HTMLElement;


  /**
   * Constructor.
   *
   * @param {HTMLElement} container Main container of the content element
   */
  protected constructor(container: HTMLElement) {
    this._container = container;
  }


  /**
   * Gets the event for checking if the content element is ready.
   *
   * @returns {EventDispatcher<void>}
   */
  get readyEvent(): EventDispatcher<void> {
    return this._readyEvent;
  }


  /**
   * Gets the main container of the content element.
   *
   * @returns {HTMLElement}
   */
  get container(): HTMLElement {
    return this._container;
  }


  /**
   * Sets the main container of the content element.
   *
   * @param {HTMLElement} container New container
   * @returns {void}
   */
  set container(container: HTMLElement) {
    this._container = container;
  }
}
